import React from 'react';
import Create from '../../../containers/rest/Create';
import Form from '../components/Form';

const OrderRequestedsCreate = props => (
  <Create {...props} resource="orderRequesteds">
    <Form />
  </Create>
);

OrderRequestedsCreate.propTypes = {};

export default OrderRequestedsCreate;
